import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { handle: String }
  
  connect() {
    this.setupSortable()
  }
  
  setupSortable() {
    // Store dragged element at instance level
    this.draggedElement = null
    this.draggedIndex = null
    
    // Add drag handlers to all items
    this.addDragHandlers()
  }
  
  addDragHandlers() {
    const items = this.element.querySelectorAll('.reorder-item')
    
    items.forEach((item, index) => {
      item.draggable = true
      
      const handle = this.handleValue ? item.querySelector(this.handleValue) : item
      
      if (handle) {
        handle.style.cursor = 'grab'
        
        handle.addEventListener('mousedown', () => {
          handle.style.cursor = 'grabbing'
        })
        
        handle.addEventListener('mouseup', () => {
          handle.style.cursor = 'grab'
        })
      }
      
      item.addEventListener('dragstart', (e) => {
        this.draggedElement = item
        this.draggedIndex = Array.from(this.element.children).indexOf(item)
        item.classList.add('dragging')
        e.dataTransfer.effectAllowed = 'move'
        e.dataTransfer.setData('text/html', item.outerHTML)
      })
      
      item.addEventListener('dragend', () => {
        item.classList.remove('dragging')
        if (handle) handle.style.cursor = 'grab'
      })
      
      item.addEventListener('dragover', (e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'
        
        if (!this.draggedElement) return
        
        const afterElement = this.getDragAfterElement(e.clientY)
        if (afterElement == null) {
          this.element.appendChild(this.draggedElement)
        } else {
          this.element.insertBefore(this.draggedElement, afterElement)
        }
      })
      
      item.addEventListener('drop', (e) => {
        e.preventDefault()
        this.updatePositions()
      })
    })
  }
  
  getDragAfterElement(y) {
    const draggableElements = [...this.element.querySelectorAll('.reorder-item:not(.dragging)')]
    
    return draggableElements.reduce((closest, child) => {
      const box = child.getBoundingClientRect()
      const offset = y - box.top - box.height / 2
      
      if (offset < 0 && offset > closest.offset) {
        return { offset: offset, element: child }
      } else {
        return closest
      }
    }, { offset: Number.NEGATIVE_INFINITY }).element
  }
  
  updatePositions() {
    const items = this.element.querySelectorAll('.reorder-item')
    items.forEach((item, index) => {
      const badge = item.querySelector('.badge')
      if (badge) {
        badge.textContent = index + 1
      }
      item.dataset.position = index
    })
    
    // Trigger position update in parent controller
    this.dispatch('positionsUpdated', { detail: { positions: this.getPositions() } })
  }
  
  getPositions() {
    const items = this.element.querySelectorAll('.reorder-item')
    return Array.from(items).map((item, index) => ({
      component_id: item.dataset.componentId,
      position: index
    }))
  }
} 